import React from 'react';
import CheckmarkIcon from '@shared/icons/CheckmarkIcon';
import SummaryBox from '@/components/SummaryBox';
import OutlineButton from '@/components/OutlineButton';
import { assignmentChargeCents, formatDate, formatMoney, frequencyNoun, paymentMethodLabel } from '@/format';

/** Web·3 — enrollment confirmation. */
const SuccessScreen = ({ status, assignment, studentName, onManage }) => {
	const chargeAt = assignment?.next_charge_at ?? assignment?.first_charge_at;

	return (
		<div className="flex flex-col items-center gap-[18px] pt-[12px]">
			<div className="flex h-[76px] w-[76px] items-center justify-center rounded-full bg-[#e7f4e4]">
				<div className="flex h-[52px] w-[52px] items-center justify-center rounded-full bg-[#4caf50] text-white">
					<CheckmarkIcon width={26} height={26} />
				</div>
			</div>

			<h1 className="text-center text-[24px] font-extrabold text-[#16181d]">Auto-Pay is on</h1>

			<p className="text-center text-[14px] leading-[21px] text-[#7d7d7d]">
				{studentName ? `${studentName}’s tuition` : 'Tuition'} will now be paid automatically. We’ll email a reminder
				before each charge and a receipt after.
			</p>

			<SummaryBox
				rows={[
					{ label: 'Payment method', value: paymentMethodLabel(status?.default_payment_method) ?? '—' },
					{
						label: 'Next charge',
						value: chargeAt
							? `${formatMoney(assignmentChargeCents(assignment), assignment.currency)} · ${formatDate(chargeAt)}`
							: '—',
					},
					{ label: 'Frequency', value: frequencyNoun(assignment?.frequency) },
				]}
			/>

			<p className="text-center text-[13px] text-[#7d7d7d]">You can safely close this window.</p>

			<OutlineButton onClick={onManage}>Manage Auto-Pay settings</OutlineButton>
		</div>
	);
};

export default SuccessScreen;
